/*
 * @Author: wp
 * @Date: 2022-12-30 15:42:51
 * @Descripttion:
 */
import ElementUI from 'element-ui'
import Compressor from 'compressorjs'

export function copyToClip (content, message) {
    const aux = document.createElement('input')
    aux.setAttribute('value', content)
    document.body.appendChild(aux)
    aux.select()
    document.execCommand('copy')
    document.body.removeChild(aux)
    if (message == null) {
        ElementUI.Message({
            message: '复制成功',
            type: 'success'
        })
    } else {
        ElementUI.Message({
            message,
            type: 'success'
        })
    }
}
function isToday (str) {
    const d = new Date(str.replace(/-/g, '/'))
    const todaysDate = new Date()
    if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
        return true
    } else {
        return false
    }
}
export function conversationTime (data) {
    const time = new Date(data)
    const Y = time.getFullYear()
    const Mon = time.getMonth() + 1
    const Day = time.getDate()
    const H = time.getHours()
    const Min = time.getMinutes()
    const S = time.getSeconds()
    const str = `${Y}-${Mon}-${Day}`
    if (isToday(str)) {
        return `${H}:${Min < 10 ? '0' + Min : Min}`
    } else {
        return `${Mon}-${Day}`
    }
}
export function timeFilter (item) {
    if (!item) {
        return item
    }
    const date = new Date(item)
    const now = new Date()
    if (date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate()) {
        // 今天
        item = `${Number(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours()}` + ':' + `${Number(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    } else if (date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && now.getDate() - date.getDate() == 1) {
        // 昨天
        item = `昨天 ${Number(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours()}:${Number(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    } else if (date.getFullYear() == now.getFullYear()) {
        // 同年显示月
        item =
			date.getMonth() +
			1 +
			'月' +
			date.getDate() +
			'日 ' +
			`${Number(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours()}` +
			':' +
			`${Number(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    } else {
        // 不同年
        item =
			date.getFullYear() +
			'年' +
			(date.getMonth() + 1) +
			'月' +
			date.getDate() +
			'日 ' +
			`${Number(date.getHours()) < 10 ? '0' + date.getHours() : date.getHours()}` +
			':' +
			`${Number(date.getMinutes()) < 10 ? '0' + date.getMinutes() : date.getMinutes()}`
    }
    return item
}
// 压缩base64图片
export function compressImage (base64, maxSize) {
    return new Promise(async (resolve, reject) => {
        const _tempBase = base64
        const regex = /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i
        // if (!regex.test(base64)) {
        // 	_tempBase = await fileToBase64(base64);
        // }
        console.log('_tempBase=======================', _tempBase.split(','))
        const targSize = maxSize * 1024
        // if (_tempBase.length <= targSize) {
        //     resolve(_tempBase.split(',')[1])
        // }
        const newImage = new Image()
        newImage.src = _tempBase
        // newImage.setAttribute('crossOrigin', Anonymous); // url为外域时需要
        newImage.onload = function () {
            try {
                let quality = 0.95 // 压缩系数 0-1 之间
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                ctx.clearRect(0, 0, canvas.width, canvas.height)
                ctx.drawImage(this, 0, 0, canvas.width, canvas.height)
                let _base64 = canvas.toDataURL('image/jpeg', quality)
                while (_base64.length > targSize) {
                    quality -= 0.05
                    _base64 = canvas.toDataURL('image/jpeg', quality)
                }
                resolve(_base64.split(',')[1])
            } catch (error) {
                reject(error)
            }
        }
    })
}
// 文件转base64
export function toBase64 (file) {
    return new Promise(async (resolve, reject) => {
        const fileReader = new FileReader()
        const prefixToRemove = /^data:image\/\w+;base64,/
        fileReader.onload = event => {
            const base64String = event.target.result
            const base64 = base64String.replace(prefixToRemove, '')
            resolve(base64)
        }
        // 读取文件并转换为 Base64
        fileReader.readAsDataURL(file)
    })
}
/**
 *
 * @param {*} url 网络图片地址
 * @returns {string} 图片base64
 */
export function imageUrlToBase64 (url) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = function () {
            if (this.status === 200) {
                const reader = new FileReader()
                reader.readAsDataURL(this.response)
                reader.onloadend = function () {
                    const base64data = reader.result
                    resolve(base64data)
                }
            } else {
                reject(new Error(this.statusText))
            }
        }
        xhr.onerror = function () {
            reject(new Error('Network error'))
        }
        xhr.send()
    })
}
export function comporessImgToTargetSize_IMG_MSG_CONTENT (file, targetSize) {
    // 精确减法
    function minus (num1, num2) {
        const num1Digits = (num1.toString().split('.')[1] || '').length
        const num2Digits = (num2.toString().split('.')[1] || '').length
        const baseNum = 10 ** Math.max(num1Digits, num2Digits)
        return (num1 * baseNum - num2 * baseNum) / baseNum
    }

    async function compressImg (file, targetSize) {
        let currentFile = file
        let currentSize = file.size

        let quality = 0.8

        let isError = false
        while (currentSize > targetSize && quality > 0 && !isError) {
            // quality -= 0.1
            quality = minus(quality, 0.2)

            try {
                await new Promise((resolve1, reject1) => {
                    const widthQuality = quality * 10
                    // eslint-disable-next-line no-new
                    new Compressor(currentFile, {
                        width: 20 * widthQuality,
                        quality,
                        success (result) {
                            currentFile = result
                            currentSize = result.size
                            resolve1()
                        },
                        error (err) {
                            reject1(err)
                        }
                    })
                })
            } catch (error) {
                console.error('compressImg=>压缩失败', error)
                isError = true
            }
        }
        if (quality <= 0) {
            isError = true
        }
        return { currentFile, isError }
    }

    return new Promise((resolve, reject) => {
        if (!(file instanceof File) && !(file instanceof Blob)) {
            reject(new Error('Invalid input: not a File or Blob object.'))
            return
        }

        compressImg(file, targetSize)
            .then(({ currentFile, isError }) => {
                resolve({ res: currentFile, success: !isError })
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 * 调用 utils.compressImg 的快捷方法
 * @param {*} file
 * @param {*} targetSize
 * @returns
 */
export function compressImages (file, targetSize) {
    return new Promise(async (resolve, reject) => {
        if (!(file instanceof File) && !(file instanceof Blob)) {
            reject(new Error('你传进来的文件类型不是blob或file.'))
            return
        }

        compressImgs(file, targetSize)
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 *
 * @param {File} fileOrBlob 文件对象
 * @returns {Promise<string>} base64
 */
export function fileToBase64 (fileOrBlob) {
    return new Promise((resolve, reject) => {
        if (!(fileOrBlob instanceof File) && !(fileOrBlob instanceof Blob)) {
            reject(new Error('Invalid input: not a File or Blob object.'))
            return
        }

        const reader = new FileReader()

        reader.onload = () => {
            resolve(reader.result)
        }

        reader.onerror = () => {
            reject(new Error('Failed to read file or blob.'))
        }

        reader.readAsDataURL(fileOrBlob)
    })
}
/**
 * 压缩图片
 * @param {*} file 文件
 * @param {*} targetSize 压缩大小
 * @returns
 */
export async function compressImgs (file, targetSize) {
    let currentFile = file
    let currentSize = file.size
    let quality = 1
    while (currentSize > targetSize && quality > 0) {
        quality -= 0.1
        await new Promise(async (resolve1, reject1) => {
            new Compressor(currentFile, {
                width: 480 * quality,
                quality,
                success (result) {
                    currentFile = result
                    currentSize = result.size
                    resolve1()
                },
                error (err) {
                    reject1(err)
                }
            })
        })
    }
    if (quality <= 0) { throw new Error('图片压缩失败,compress quality <= 0') }
    return currentFile
}

// 随机数
export function random_string (len) {
    len = len || 32
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    const maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
}
// 判断是否可视区域可见
export function isInViewPort (element) {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth
    const viewHeight = window.innerHeight || document.documentElement.clientHeight
    const { top, right, bottom, left } = element.getBoundingClientRect()

    return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight
}
// 获取时间戳相差值
export function getTimeDifference (timestamp1, timestamp2) {
    const date = Math.abs(timestamp1 - timestamp2)
    // let difference = Math.floor(date / 1000 / 60)
    return date
}
/**
 * @description 深拷贝函数 首先检查传递给函数的参数是否为 null 或不是一个对象。如果是, 则直接返回该值。可以实现数组或对象深拷贝，但不能处理函数
 * @param {*} obj
 * @param {*} map
 * @returns 深拷贝结果
 */
export function deepClone (target) {
    // 定义检测数据类型的功能函数
    function checkedType (target) {
        return Object.prototype.toString.call(target).slice(8, -1)
    }
    // 初始化变量result 成为最终克隆的数据
    let result
    const targetType = checkedType(target)
    if (targetType === 'object') {
        result = {}
    } else if (targetType === 'Array') {
        result = []
    } else {
        return target
    }
    // 遍历目标数据
    for (const i in target) {
        // 获取遍历数据结构的每一项值。
        const value = target[i]
        // 判断目标结构里的每一值是否存在对象/数组
        if (checkedType(value) === 'Object' || checkedType(value) === 'Array') {
            // 对象/数组里嵌套了对象/数组
            // 继续遍历获取到value值
            result[i] = deepClone(value)
        } else {
            // 获取到value值是基本的数据类型或者是函数。
            result[i] = value
        }
    }
    return result
}
/**
 * 防抖
 */
export function debounce (fn, delay = 300, immediate = true) {
    let timer
    return function () {
        const context = this
        const args = arguments
        if (immediate && !timer) {
            fn.apply(context, args)
        }
        clearTimeout(timer)
        timer = setTimeout(function () {
            if (!immediate) {
                fn.apply(context, args)
            }
            timer = null
        }, delay)
    }
}
/**
 * 节流
 */
export function throttle (fn, delay = 300, immediate = true) {
    let timer = null
    return function () {
        const that = this
        const arg = arguments
        if (immediate) {
            if (!timer) {
                timer = setTimeout(() => {
                    timer = null
                }, delay)
                fn.apply(that, arg)
            }
        } else if (!timer) {
            timer = setTimeout(() => {
                timer = null
                fn.apply(that, arg)
            }, delay)
        }
    }
}
/**
 * 不刷新页面在地址栏上加参数
 * 用法 addQueryParams({ ...this.$route.query, status: 'WAIT_PAY' })
 */
export function addQueryParams (params) {
    const currentUrl = window.location.href
    const existingParams = new URLSearchParams(currentUrl.split('?')[1] || '')
    for (const key in params) {
        existingParams.set(key, params[key])
    }
    const newUrl = `${currentUrl.split('?')[0]}?${existingParams.toString()}`
    history.pushState({}, null, newUrl)
}
/**
 * 时间戳
 */
export function fixTime (time, timezone = 8) {
    if (!time) { return time }
    const date = new Date(time.replace(/-/g, '/'))
    const localTime = date.getTime()
    const localOffset = date.getTimezoneOffset() * 60000
    const utc = localTime - localOffset // 得到UTC时间
    const fixedTime = utc - 3600000 * timezone // 时区修正
    return fixedTime
}
/**
 * IM商品链接跳转
 */
export function imLinkJump (item) {
    return `/goodsDetails/${item.goodsId}/${item.goodsCatalogueId}`
}
/**
 * 多标签登出登入
 */
export function pzLoginStorage () {
    const status = {
        loggedOut: '0', // 已退出
        loggedIn: '1', // 已登录
        pending: '2' // 待登录
    }
    const key = 'pzLoginStatus'
    const onLoggedIn = () => {
        localStorage.setItem(key, status.loggedIn)
    }
    const onPending = () => {
        localStorage.setItem(key, status.pending)
    }
    const onLoggedOut = () => {
        localStorage.setItem(key, status.loggedOut)
    }
    const onRemove = () => {
        localStorage.removeItem(key)
    }
    return {
        key,
        onLoggedIn,
        onPending,
        onLoggedOut,
        onRemove,
        status
    }
}
// 花呗分期计算
/**
 *
 * @param {*} totalAmount 总金额
 * @param {*} months 分期数
 * @param {*} rate 费率
 */
export function calculateInstallmentAmount (totalAmount, months, rate) {
    // 1. 转换金额为分为单位
    const totalAmountInFen = Math.round(totalAmount * 100) // 将金额转换为分

    // 2. 计算每期本金（用总金额/总期数，结果以分表示，向下取整）
    const principalPerMonth = Math.floor(totalAmountInFen / months) // 每期本金（单位：分）

    // 3. 用转换为分后的金额乘以买家费率，得到以分表示的买家总费用，使用 ROUND_HALF_EVEN 规则取整
    const totalFee = Math.round((totalAmountInFen * rate) / 100) // 总手续费（单位：分）

    // 4. 计算每期手续费（用总费用/总期数，结果以分表示，向下取整）
    const feePerMonth = Math.floor(totalFee / months) // 每期手续费（单位：分）

    // 5. 计算每期总费用（每期本金 + 每期手续费），结果以分表示
    const totalPerMonth = principalPerMonth + feePerMonth // 每期总费用（单位：分）

    // 6. 将计算结果转换为元并保留两位小数
    return {
        feePerMonth: (feePerMonth / 100).toFixed(2), // 每期手续费（单位：元）
        totalPerMonth: (totalPerMonth / 100).toFixed(2) // 每期总费用（单位：元）
    }
}

/**
 * @description 商品列表中格式化想要人数和看过人数
 * @param {number} num 数字 示例：10000 10001
 * @returns {string} 格式化后的数字 示例：10000 转为 1w 10001 转为 1.1w
 */
export function formatCount(num) {
	if (num == null || Number.isNaN(num))
		return 0
	const n = Number(num)
	if (n < 10000)
		return n
	if (n === 10000)
		return '1w'
	const val = Math.ceil(n / 1000) / 10
	return `${val.toFixed(1)}w`
}

export function fixApiTimeToUTC8(time, timezone = 8) {
    if (!time)
        return time
    const targetDate = new Date(time.replace(/-/g, '/'))
    const targetTimeStamp = targetDate.getTime()

    const currentTimeZone = new Date().getTimezoneOffset()
    const utc = targetTimeStamp - currentTimeZone * 60000 // 得到UTC时间
    const fixedTime = utc - 3600000 * timezone // 时区修正
    return fixedTime
}

/**
 * @description 商品列表中格式化显示发布时间
 * @param {string} onStandTime 发布时间 示例：2025-09-06 10:00:00
 * @returns {string} 格式化后的发布时间 示例：10分钟前发布 23小时前发布
 */
export function getReleaseTimeString(onStandTime) {

    if (!onStandTime)
        return ''

    const releaseTimeStamp = fixApiTimeToUTC8(onStandTime)
    const diff = Date.now() - releaseTimeStamp

    if (diff <= 0)
        return ''

    const minute = 60 * 1000
    const hour = 60 * minute
    const day = 24 * hour

    // 当0 < 传入时间 < 1h，展示文案: xx分钟前发布
    if(diff < minute) {
        return '刚刚发布'
    }
    else if (diff < hour) {
        const minutes = Math.floor(diff / minute)
        return `${minutes}分钟前发布`
    }
    // 当1h ≤ 传入时间，仅展示小时，退位展示，最多展示23个小时
    else if (diff < day) {
        const hours = Math.floor(diff / hour)
        // 确保最多只显示23个小时
        const displayHours = Math.min(hours, 23)
        return `${displayHours}小时前发布`
    }
    else {
        return ''
    }
}
